"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./utils");
var social_groups_api_1 = require("@wix/social-groups-api");
var GroupDTO_1 = require("@wix/social-groups-api/dist/src/model/Group/GroupDTO");
var loggers_1 = require("@wix/social-groups-common/dist/src/loggers");
var selectors_1 = require("../components/Group/Discussion/Reactions/selectors");
var routeParams_1 = require("../controllers/routeParams");
var utils_2 = require("@wix/social-groups-common/dist/src/utils");
var GroupSEOItemType_1 = require("./GroupSEOItemType");
var ContentConverter_1 = require("@wix/social-groups-common/dist/src/components/ContentEditor/content/ContentConverter");
var GroupApps_1 = require("@wix/social-groups-api/dist/src/model/GroupApps/GroupApps");
// TODO: content(group description, feed items content) should be in plain text
var SeoGroupBuilder = /** @class */ (function () {
    function SeoGroupBuilder(initialProps) {
        var _a;
        var _this = this;
        this.initialProps = initialProps;
        this.getFeedItemData = function () {
            return {
                feedItems: utils_1.feedItemsWithPlainTextContent(_this.initialProps.feedItems),
            };
        };
        this.getAboutItemData = function () {
            return {};
        };
        this.getMembersItemData = function () {
            return {
                groupMembers: _this.initialProps.siteMembers.filter(social_groups_api_1.isGroupMember),
            };
        };
        this.getPostItemData = function () {
            var _a = _this.initialProps, feedItems = _a.feedItems, siteMembersMap = _a.siteMembersMap, location = _a.location;
            var _b = _this.routeParams, feedItemId = _b.feedItemId, groupId = _b.groupId;
            if (feedItemId) {
                var post = feedItems.find(function (item) { return item.feedItemId === feedItemId; });
                if (post) {
                    var postAuthor = siteMembersMap[post.createdBy] || social_groups_api_1.Anonymous;
                    var usersReactionsMap = selectors_1.getReactionsSummaryMap(post.reactions.usersReactions.reactions, siteMembersMap);
                    var likeSummary = selectors_1.getLikeSummary(usersReactionsMap);
                    return {
                        groupDirectUrl: utils_2.getGroupUrl(location.baseUrl, groupId),
                        author: postAuthor,
                        post: utils_1.feedItemWithPlainTextContent(post),
                        images: utils_1.feedItemImages(post),
                        interactionStatistic: likeSummary.total,
                    };
                }
            }
            return {};
        };
        this.itemDataBuilders = (_a = {},
            _a[GroupSEOItemType_1.GroupSEOItemType.GROUPS_MEMBERS] = this.getMembersItemData,
            _a[GroupSEOItemType_1.GroupSEOItemType.GROUPS_MEDIA] = this.getFeedItemData,
            _a[GroupSEOItemType_1.GroupSEOItemType.GROUPS_ABOUT] = this.getAboutItemData,
            _a[GroupSEOItemType_1.GroupSEOItemType.GROUPS_FEED] = this.getFeedItemData,
            _a[GroupSEOItemType_1.GroupSEOItemType.GROUPS_POST] = this.getPostItemData,
            _a[GroupSEOItemType_1.GroupSEOItemType.GROUPS_COMMENT] = this.getPostItemData,
            _a);
    }
    SeoGroupBuilder.prototype.withGroup = function () {
        if (this.itemData && this.itemData.group) {
            return this;
        }
        var _a = this.initialProps, group = _a.group, apps = _a.apps, location = _a.location, translation = _a.translation;
        var groupDTO = new GroupDTO_1.GroupDTO(group);
        var description = ContentConverter_1.ContentConverter.parseText(groupDTO.getDescription());
        var logo = { height: 300, width: 300 };
        var logoUrl = groupDTO.getScaledLogo(logo.width, logo.height);
        var g = groupDTO.setDetails({ description: description, logoUrl: logoUrl, logo: logo });
        var groupApps = GroupApps_1.GroupApps.fromAppsMap(apps);
        this.itemData = {
            directUrl: location.url,
            group: g,
            tabs: groupApps.getTabsMap(translation),
        };
        return this;
    };
    SeoGroupBuilder.prototype.getItemData = function () {
        try {
            var dataBuilder = this.itemDataBuilders[this.itemType];
            if (dataBuilder) {
                var itemData = dataBuilder();
                return tslib_1.__assign({}, this.itemData, itemData);
            }
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
        return this.itemData || {};
    };
    SeoGroupBuilder.prototype.forLocation = function (location) {
        this.routeParams = routeParams_1.groupRoute(location);
        this.itemType = utils_1.getGroupSEOItemType(this.routeParams);
        if (this.itemData) {
            this.itemData.directUrl = location.url;
        }
        return this;
    };
    SeoGroupBuilder.prototype.build = function () {
        return {
            itemType: this.itemType,
            itemData: this.getItemData(),
        };
    };
    return SeoGroupBuilder;
}());
exports.SeoGroupBuilder = SeoGroupBuilder;
//# sourceMappingURL=SeoGroupBuilder.js.map